<template>
    <div id="userProfile">
        <!-- <p class="view-title" v-show=>用户信息</p> -->
        <div class="view-content"  :style="$route.path=='/CompanyConsole/userProfile' ?{'top': '16px'}: null">
            <div class="user-left-box">
                <span class="back" @click="$router.go(-1)"><img :src="back"> 个人中心</span>
                <div class="user-img">
                    <img :src="`${$store.state.imgUrl+userData.avatar}`" ref='addImg'class="headImg">
                    <p class="edit-img" @click="editAvatar" v-show="!$store.state.isLook" >修改头像</p>
                    <p v-show="$store.state.isLook" class="edit-img islook-txt">修改头像</p>
                </div>
                <div class="user-details">
                    <p>账号：{{userData.userName}}
                        <span class="m-l-0" @click="operate('editPass','passForm')" v-show="!$store.state.isLook" >修改密码</span>
                        <span class="m-l-0 islook-txt" v-show="$store.state.isLook" >修改密码</span>
                    </p>
                    <p>姓名：{{userData.displayName}}
                        <span @click="operate('editName','nameForm')" v-show="!$store.state.isLook" >修改姓名</span>
                        <span v-show="$store.state.isLook" class="islook-txt">修改姓名</span>
                    </p>
                    <p>组织：{{userData.groupName}}</p>
                    <p>手机号：{{hidePhone(userData.mobile)}}
                        <span @click="operate('editphone','phoneForm')" v-show="!$store.state.isLook" >修改手机号</span>
                        <span v-show="$store.state.isLook" class="islook-txt">修改手机号</span>
                    </p>
                    <p>公众号：{{userData.wechatId=="" || userData.wechatId== null ? '未绑定':"已绑定"}}</p>
                </div>
            </div>
            <div class="user-right-box">
                <div class="user-qrCode">
                    <img :src="qrCode" ref='addImg' class="qrcode">
                    <p>扫码关注 “永捷机电” 公众号</p>
                    <p>获取最新资讯及移动端入口信息</p>
                </div>
                <div class="user-explain">
                    <p>绑定公众号操作流程:</p>
                    <p>1.打开微信扫描二维码，关注公众号 “永捷机电” 。</p>
                    <p>2.按照页面提示绑定用户账号。</p>
                    <p>3.绑定成功后即可通过微信公众号推送消息获取报警等内容。</p>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 修改密码 -->
            <div class="popup-editPass" v-show='editPassShow'>
                <div class="popup-title">
                    修改密码<i class="el-icon-circle-close close" @click="close('editPass')"></i>
                </div>
                <div class="popup-lab">
                    <div class="edit-box">
                        <el-form :model='ruleForm' :rules="rules" ref="passForm" class="clearfix">
                            <el-form-item prop="oldPass" label="请输入旧密码：" autocomplete="off">
                                <el-input v-model="ruleForm.oldPass" show-password></el-input>
                            </el-form-item>
                            <el-form-item prop="newPass" label="请输入新密码：" autocomplete="off">
                                <el-input v-model="ruleForm.newPass" show-password placeholder="请输入8位密码，其中包含大小写字母、数字"></el-input>
                            </el-form-item>
                            <el-form-item prop="newPass2" label="确认新密码：" autocomplete="off">
                                <el-input v-model="ruleForm.newPass2" show-password placeholder="请输入8位密码，其中包含大小写字母、数字"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <p class="btn-box"><el-button type="primary" @click="editPass('passForm')">确定</el-button> <el-button @click="close('editPass')">取消</el-button></p>
            </div>
            <!-- 修改手机号 -->
            <div class="popup-editPhone" v-show="editphoneShow">
                <div class="popup-title">
                    修改手机号<i class="el-icon-circle-close close" @click="close('editphone')"></i>
                </div>
                <div class="popup-lab">
                    <div class="phone-box">
                        <el-form :model="ruleForm" :rules="rules" ref="phoneForm" class="clearfix">
                            <el-form-item prop="phone" autocomplete="off" class="m-b-36">
                                <el-input v-model="ruleForm.phone" placeholder="请输入11位手机号(不能包含英文和标点)"></el-input>
                            </el-form-item>
                            <el-form-item prop="verifyCode" autocomplete="off" class="m-b-36">
                                <el-input v-model.number="ruleForm.verifyCode" placeholder="请输入4位验证码(不能包含英文和标点)" class="verificationCode"></el-input>
                                <div class="code-box">
                                    <p class="get-code" v-show="getCodeShow" @click.stop='getCode'>{{timerTxt}}</p>
                                    <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <p class="btn-box"><el-button type="primary" @click="editphone('phoneForm')">确定</el-button> <el-button @click="close('editphone')">取消</el-button></p>
            </div>
            <!-- 修改用户名 -->
            <div class="popup-editname" v-show="editNameShow">
                <div class="popup-title">
                    修改用户名<i class="el-icon-circle-close close" @click="close('editName')"></i>
                </div>
                <div class="popup-lab m-t-11">
                    <div class="name-box">
                        <el-form :model="ruleForm" :rules="rules" ref="nameForm" class="clearfix" @submit.native.prevent>
                            <el-form-item prop="userName" autocomplete="off" label="请输入用户名：">
                                <el-input v-model="ruleForm.userName"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <p class="btn-box"><el-button type="primary" @click="editName('nameForm')">确定</el-button> <el-button @click="close('editName')">取消</el-button></p>
            </div>
            <!-- 修改头像 -->
            <div class="popup-headImg" v-show="editImgShow">
                <i class="el-icon-circle-close close" @click="close('editImg')"></i>
                <div class="img-box">
                    <img :src="`${$store.state.imgUrl+userData.avatar}`" class="c-pointer" @click="editAvatar" ref="editImg">
                    <p class="edit-img" @click="editAvatar">上传头像</p>
                    <span class="logo-box"><input type="file" ref="addfile" class="file" accept="image/*"></span>
                </div>
                <p class="btn-box"><el-button type="primary" @click="editImg">确定</el-button> <el-button @click="close('editImg')">取消</el-button></p>
                <p class="img-tips" ref="tips">仅支持小于2MB的JPG和PNG文件</p>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        var validateName = (rule, value, callback) =>{
            let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" || value == null){
                callback(new Error('用户名称不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var validatePhone = (rule, value, callback) =>{
            let reg=/^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
            if(value == "" || value == null){
                callback(new Error('手机号不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('请输入正确的手机号码'));
            }else{
                callback();
            }
        }
        var verifyCode = (rule, value, callback) =>{
            if(value == "" || value == null){
                callback(new Error('验证码不能为空'));
            }else if(!Number.isInteger(value) || String(value).length != 4){
                callback(new Error('请输入4位验证码(不能包含英文和标点)'));
            }else{
                callback();
            }
        }
        var validatePass = (rule, value, callback) =>{
            let reg =  /^(?=.*[A-Za-z])(?=.*\d)[^]{8,16}$/;
            if(value == "" || value == null){
                callback(new Error('新密码不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('密码必须为8~16位，同时包含英文和数字'));
            }else{
                callback();
            }
        }
        var validatePass2 = (rule, value, callback) =>{
            if(value == "" || value == null){
                callback(new Error('确认密码不能为空'));
            }else if(value != this.ruleForm.newPass){
                callback(new Error('确认密码与新密码不一致'));
                this.ruleForm.confirmPass = "";
            }else{
                callback();
            }
        }
        return {
            logo:require('@/assets/image/company/logo.png'),
            qrCode:require('@/assets/image/index/qrcode.jpg'),
            // qrCode:require('@/assets/image/index/qrcode.png'),
            back:null,
            editPassShow:false,
            editphoneShow:false,
            editNameShow:false,
            editImgShow:false,
            getCodeShow:true,
            countdownShow:false,
            second:60,
            timerTxt:"获取验证码",
            timer:null,         //定时器
            ruleForm:{          //表单数据
                oldPass:"",
                newPass:"",
                newPass2:"",
                phone:"",
                verifyCode:null,
                userName:"",
                file:"",
            },
            rules:{
                oldPass:[{ required: true, message:"旧密码不能为空", trigger: 'blur'}],
                newPass:[{ required: true, validator: validatePass, trigger: 'blur'}],
                newPass2:[{ required: true, validator: validatePass2, trigger: 'blur'}],
                phone:[{ required: true, validator: validatePhone, trigger: 'blur'}],
                verifyCode:[{ required: true, validator: verifyCode, trigger: 'blur'}],
                userName:[{ required: true, validator: validateName, trigger: 'blur'}],
            },
            userData:{},
            setFile:false,
        }
    },
    created() {
        this.back = require('@/assets/image/index/back'+this.cssType+'.png')
        this.getUser()
        this.$store.state.mask=false
    },
    methods: {
        getUser(){
            this.get('/UserProfile/get').then((res)=>{
                if(res.success){
                    this.userData=res.result;
                    this.$store.state.userData = this.clone(this.userData);
                }
            })
        },
        //打开弹窗
        operate(name,formName){
            this.$refs[formName].clearValidate()
            name += "Show";
            this[name]=true;
            this.$store.state.mask=true;
            // console.log(this.ruleForm)

            if(name=="editNameShow"){
                this.ruleForm.userName = this.userData.displayName;
            }
        },
        // 关闭弹窗
        close(name){
            this.$store.state.mask=false;
            let show = name + "Show";
            this[show]=false;
            if(show=="editphoneShow"){
                this.getCodeShow = true;
                this.countdownShow=false;
                clearInterval(this.timer);
                this.timer = null;
            }
            this.ruleForm = this.$options.data().ruleForm
        },
        //获取验证码
        getCode(){
          // console.log(this.$refs.phoneForm.validateField('phone'))
          this.$refs.phoneForm.validateField('phone',(err)=>{
            if(!err){
              this.post('/UserProfile/sendVerifyCode',{mobile:this.ruleForm.phone,firstBind:"first"}).then((res)=>{
                  if(res.success){
                      this.getCodeShow=false;
                      this.countdownShow=true;
                      const TIME_COUNT = 60;
                      this.$message({
                          message: '验证码发送成功',
                          type: 'success'
                      });
                      if (!this.timer) {
                          this.second = TIME_COUNT;
                          this.timer = setInterval(() => {
                              if (this.second > 0 && this.second <= TIME_COUNT) {
                                  this.second--;
                              } else {
                                  this.getCodeShow = true;
                                  this.countdownShow=false;
                                  this.timerTxt = "再次获取";
                                  clearInterval(this.timer);
                                  this.timer = null;
                              }
                          }, 1000)
                      }
                  }else{
                      this.$message({
                          message: `验证码发送失败：${res.message}`,
                          type: 'warning'
                      });
                  }
              })
            }
          })
        },
        //修改用户名
        editName(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        name:this.ruleForm.userName
                    }
                    this.post('/UserProfile/updateName',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            });
                            this.userData.displayName = parm.name;
                            sessionStorage.setItem('userData',JSON.stringify(this.userData))
                            this.$store.state.mask=false;
                            this.editNameShow = false;
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                type: 'warning',
                                message: `修改失败:${res.message}`
                            });
                        }
                    })
                }
            })
        },
        //修改手机
        editphone(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        mobile:this.ruleForm.phone,
                        verifyCode:this.ruleForm.verifyCode
                    }
                    this.post('/UserProfile/updateMobile',parm).then((res)=>{
                        // console.log(res)
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            });
                            this.userData.mobile = parm.mobile;
                            sessionStorage.setItem('userData',JSON.stringify(this.userData))
                            this.$store.state.mask=false;
                            this.editphoneShow = false;
                            this.timerTxt = "获取验证码";
                            this.ruleForm = this.$options.data().ruleForm;
                            this.getCodeShow = true;
                            this.countdownShow = false;
                            clearInterval(this.timer);
                            this.timer = null;
                        }else{
                            this.$message({
                                type: 'warning',
                                message: `修改失败:${res.message}`
                            });
                        }
                    })
                }
            })
        },
        //修改密码
        editPass(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let parm = {
                        oldPassword:this.ruleForm.oldPass,
                        newPassword:this.ruleForm.newPass
                    }
                    this.post('/UserProfile/updatePassword',parm).then((res)=>{
                        // console.log(res)
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            });
                            this.$store.state.mask=false;
                            this.editPassShow = false;
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                type: 'warning',
                                message: `修改失败:${res.message}`
                            });
                            this.ruleForm.oldPass = "";
                        }
                    })
                }
            })
        },
        //上传头像
        editAvatar(){
            this.setFile = true;
            let inp = this.$refs.addfile;
            inp.click();
            let that = this;
            inp.onchange = function(e) {
                let fileList =that.$refs.addfile.files;   //获取上传文件
                let file = fileList[0];                     //文件参数
                let size = file.size/1024;                  //文件大小
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file)              //读取图片
                fileReader.addEventListener('load', function() {
                    that.ruleForm.file = fileReader.result; // 读取完成
                    that.$refs.editImg.src = that.ruleForm.file;
                    if(size/1024 > 2){
                        // that.$refs.tips.style.display ='block';
                        this.$message({
                            type:'warning',
                            message:'文件大小不能超过2M,请重新选择'
                        })
                        return
                    }else{
                        that.$refs.tips.style.display ='none';
                        that.editImg()
                    }
                })
            }
        },
        //修改头像
        editImg(){
            let parm={};
            if(this.setFile){
                parm = {
                    file:this.dataURItoBlob(this.ruleForm.file)
                }
            }else{
                // console.log(this.userData.avatar)
                parm = {
                    file:this.userData.avatar == undefined?"":this.userData.avatar
                }
            }
            let formdata = new FormData();
            Object.keys(parm).map(key=>{
                formdata.append(key,parm[key]);
            });
            this.postForm('/UserProfile/updateAvatar',formdata).then((res)=>{
                if(res.success){
                    this.userData.avatar = res.result;
                    this.$store.state.userData.avatar = res.result
                    localStorage.setItem('userData',JSON.stringify(this.userData))
                    this.$store.state.mask=false;
                    this.editImgShow = false;
                    this.ruleForm = this.$options.data().ruleForm;
                    this.setFile =false
                    this.$message({
                        type: 'success',
                        message: '修改成功'
                    });
                }else{
                    this.$message({
                        type: 'warning',
                        message: `修改失败：${res.message}`
                    });
                }

                // if(res.success){
                //     this.$message({
                //         type: 'success',
                //         message: '修改成功'
                //     });
                //     console.log(res.result)
                //     this.$store.state.mask=false;
                //     this.editImgShow = false;
                //     this.userData.avatar = res.result;
                //     this.ruleForm = this.$options.data().ruleForm;
                //     this.setFile =false
                // }else{
                //     this.$message({
                //         type: 'warning',
                //         message: `修改失败:${res.message}`
                //     });
                // }
            })
        },
    },
}
</script>
<style scoped>
    #userProfile{
        text-align: left;
        padding: 0 16px;
    }
    .view-title{
        font-size: 16px;
        color: #373737;
        position: relative;
        left: -15px;
        /* margin-top: 12px; */
    }
    .view-content{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 99%;
        right: 0;
        /* height: 100%; */
        background: #fff;
        min-width: 1090px;
    }
    .view-content>div{
        width: 49%;
        height: 100%;
        float: left;
        background-color: #fff;
    }
    .user-img{
        margin-top: 68px;
        text-align: center;
    }
    .user-qrCode{
        margin-top: 183px;
        text-align: center;
        font-size: 16px;
    }
    .user-left-box{
        margin-right: 18px;
        position: relative;
    }
    .file{
        display: none;
    }
    .edit-img{
        color: #5087e4;
        cursor: pointer;
        font-size: 16px;
        margin-top: 12px;
    }
    .headImg{
        border-radius: 50%;
        width: 188px;
        height: 188px;
    }
    .qrcode{
        width: 158px;
        margin-bottom: 28px;
    }
    .user-details{
        width: 74%;
        margin: 0 auto;
    }
    .user-details p{
        line-height: 54px;
        font-size: 16px;
        color: #373737;
        border-bottom: 1px solid #efefef;
    }
    .user-details span{
        color: #5087e4;
        cursor: pointer;
        float: right;
        margin-right: 16px;
    }
    .back{
        position: absolute;
        left: 16px;
        top: 12px;
        font-size: 14px;
        cursor: pointer;
    }
    .back img{
      width: 18px;
      position: relative;
      top: 2px;
    }
    .m-l-0{
        margin-left: 0 !important;
    }
    .user-explain{
        font-size: 16px;
        width:84%;
        margin: 84px auto 0 auto;
        height: 200px;
        background-color: #f5f5f6;
        line-height: 36px;
        padding: 28px 0 0 10%;
    }
    .edit-box{
        width: 333px;
        margin: 0 auto;
    }
    .phone-box{
        width: 384px;
        margin: 64px auto 0 auto;
    }
    .code-box {
        float: right;
        width: 110px;
        line-height: 36px;
        text-align: center;
        color: #fff;
    }
    .get-code{
        background-color: #409eff;
        border-radius: 5px;
    }
    .countdown{
        background-color: #c2c2c2;
        border-radius: 5px;
    }
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 20%;
        left:50%;
        width: 498px;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-249px;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px !important;
        margin-top: 22px !important;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    .popup-editPass,.popup-editPhone{
        height: 462px;
    }
    .popup-editname{
        height: 308px;
    }
    .popup-headImg{
        height: 462px;
    }
    .verificationCode{
        width:  264px;
    }
    #userProfile .el-form-item.m-b-36{
        margin-bottom: 36px !important;
    }
    .m-t-11{
        margin-top: -11px !important;
    }
    .img-box{
        margin-top: 88px;
        text-align: center;
    }
    .img-box img{
        width: 188px;
        height: 188px;
        border-radius: 50%;
    }
    .img-tips{
        text-align: center;
        color: #F56C6C;
        display: none;
    }
</style>
<style>
    #userProfile .popup .el-input__inner{
        line-height: 36px !important;
        height: 36px !important;
        padding: 0 10px !important;
    }
    #userProfile .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 8px !important;
    }
    #userProfile .popup .el-form-item__label{
        padding: 0 !important;
    }
    #userProfile .popup .el-form-item__content{
        line-height: 36px !important;
    }

    .popup .verificationCode .el-input__inner{
        width:  264px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/User/UserProfile.vue